import api from "../../config/client.axios.api";

export const deleteVoucherApi = async (eventPoint: any) => {
  const response = await api.delete(`/voucher?eventPoint=${eventPoint}`);
  return response.data;
};
